<ng-container *ngIf="componenteVisivel;else componenteNaoVisivel">
  <ng-container *ngIf="exibirTitulo">
    <div class="top-divisor"></div>
    <span class="material-icons destaque-icon primary">
      favorites
    </span>
    <label class='texto-cinza'>Em destaque</label>
  </ng-container>
  
  <div *ngIf="state === 'carregando'" class="container-carregando">
    <app-carregando-indeterminado></app-carregando-indeterminado>
  </div>
  <div *ngIf="state === 'erro'">
     <p class="texto-cinza">Ocorreu um erro ao carregar as questões em destaque, por favor, tente novamente mais tarde.</p>
  </div>
  <div *ngIf="state === 'sem_permissao'">
    <p class="texto-cinza">Sem permissão.</p>
  </div>
  
  <div class="container-resultado" *ngIf="state === 'pronto'">
    <table class="minitable container-tabela" *ngIf="questoesComRespostaDTO && questoesComRespostaDTO.length > 0">
      <thead class="thead">
        <tr class="linha" style="margin-bottom: 4px;">
          <td class="minitable-td-titulo td-head td-questao"><i class="material-icons icone-ordem">south</i>Questão</td>
          <td class="minitable-td-titulo td-head td-resposta" title="Usuário de registro">Resposta</td>
          <td class="minitable-td-titulo td-head td-data" title="Usuário de registro">Data</td>
          <td class="minitable-td-titulo td-head td-usuario" title="Usuário de registro" align="center">Usuário</td>
        </tr>
      </thead>
      
      <tbody class="minitable-tbody tbody">
        <ng-container *ngFor="let respostaDTO of questoesComRespostaDTO, let i = index">
          <tr class="minitable-linha linha">
            <td class="minitable-td-valor td-questao">
              <label class="texto-cinza-claro id-questao-label" title="ID Questão">#{{ respostaDTO.idQuestao }}</label>&nbsp;{{ respostaDTO.nomeQuestao }}
            </td>
  
            <td class="minitable-td-valor td-resposta" *ngIf="respostaDTO.descricaoResposta;else containerOpcaoQuestao">
              {{ respostaDTO.descricaoResposta }}
            </td>
  
            <ng-template #containerOpcaoQuestao>
              <td class="minitable-td-valor td-resposta">
                <ul class="ul-opcao-questao">
                  <ng-container *ngFor="let oq of respostaDTO.opcaoQuestao">
                    <li class="li-opcao-resposta">{{ oq.descricao }}</li>
                  </ng-container>
                </ul>
              </td>
            </ng-template>
  
            <td class="minitable-td-valor td-data">
              {{ respostaDTO.dataAlteracaoResposta | myDatetime }}
            </td>
  
            <td class="minitable-td-valor td-usuario" align="center">
              <app-label-avatar
                [id]="respostaDTO.idUsuarioAlteracao"
                [nome]="respostaDTO.nomeUsuarioAlteracao">
              </app-label-avatar>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-container>

<ng-template #componenteNaoVisivel>
  <div *ngIf="exibirMsgNenhumRegistro">
    <label class="texto-cinza label-sem-registro">Nenhum registro encontrado.</label>
  </div>
</ng-template>